<div class="DetallePerfil displayFlexJustify">
  <div class="img-perfil">
    <img src={{cliente.logo}} alt="" *ngIf="cliente?.logo"/>
    <img src="./../../../../assets/noimage.png" alt="" *ngIf="!cliente?.logo"/>
  </div>
  <div>
    <button (click)="openDialog()" class="editar-perfil" *ngIf="role != 'user'">Editar</button>
  </div>
  <div class="datos">
    <div class="displayFlexJustify dato">
      <div>
        <h3>Nombre Comercial</h3>
        <p>{{ cliente?.nombreComercial }}</p>
      </div>
      <div>
        <h3>Razón Social</h3>
        <p>{{ cliente?.razonSocial }}</p>
      </div>
      <div>
        <h3>CIF</h3>
        <p>{{ cliente?.cif }}</p>
      </div>
    </div>
    <div class="line"></div>

    <div class="displayFlexJustify dato">
      <div>
        <h3>Domicilio Fiscal</h3>
        <p>
          {{ cliente?.domicilio?.tipoVia }} {{ cliente?.domicilio?.nombre }},
          {{ cliente?.domicilio?.numero }},
          {{ cliente?.domicilio?.pta }}
          {{ cliente?.domicilio?.letra }}
          {{ cliente?.domicilio?.localidad }},
          {{ cliente?.domicilio?.provincia }},
          {{ cliente?.domicilio?.codigoPostal }}-
          {{ cliente?.domicilio?.ccaa }}
        </p>
      </div>
    </div>

    <div class="displayFlexJustify dato">
      <div>
        <h3>Actividad de la empresa</h3>
        <p>{{ cliente?.actividad }}</p>
      </div>
    </div>

    <div class="displayFlexJustify dato">
      <div>
        <h3>Motivo de Alta</h3>
        <p>{{ cliente?.motivoAlta }}</p> 
      </div>
    </div>

    <div class="displayFlexJustify dato">
      <div>
        <h3>Datos de contacto para Proveedores</h3>
        <p>{{ cliente?.infoContactoProveedores }}</p>
      </div>
    </div>

    <div class="line"></div>

    <h3>Datos del Responsable</h3>
    <div class="displayFlexJustify dato contactos">
      <div>
        <h4>Nombre y apellidos</h4>
        <p>{{ cliente?.contactoResponsable?.nombre }}</p>
      </div>
      <div>
        <h4>Mail de contacto</h4>
        <p>{{ cliente?.contactoResponsable?.mail }}</p>
      </div>
      <div>
        <h4>Cargo</h4>
        <p>{{ cliente?.contactoResponsable?.cargo }}</p>
      </div>
    </div>

    <h3>Contactos Adicionales</h3>
   <div
      class="displayFlexJustify dato contactos"
      *ngFor="let contacto of cliente?.contacto"
    >
      <div *ngIf="contacto.nombre != ''">
        <h4>Nombre y apellidos</h4>
        <p>{{ contacto.nombre }}</p>
      </div>
      <div *ngIf="contacto.mail != ''">
        <h4>Mail de contacto</h4>
        <p>{{ contacto.mail }}</p>
      </div>
      <div *ngIf="contacto.cargo != ''">
        <h4>Cargo</h4>
        <p>{{ contacto.cargo }}</p>
      </div>
    </div> 
  </div>
</div>
